var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgProvider2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svg/Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "styleguide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI_navigation",
    transform: "translate(-197.000000, -2038.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(197.000000, 2038.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#117093",
    x: 0,
    y: 0,
    width: 160,
    height: 160,
    rx: 80
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(20.000000, 28.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 40,
    y: 52,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 16,
    y: 40,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 16,
    y: 64,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-13",
    points: "0 28 28 28 28 96 4 96 4 40 0 40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(98.000000, 48.000000) scale(-1, 1) translate(-98.000000, -48.000000) ",
    x: 92,
    y: 40,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(98.000000, 72.000000) scale(-1, 1) translate(-98.000000, -72.000000) ",
    x: 92,
    y: 64,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-13",
    transform: "translate(106.000000, 62.000000) scale(-1, 1) translate(-106.000000, -62.000000) ",
    points: "92 28 120 28 120 96 96 96 96 40 92 40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 64,
    y: 52,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 40,
    y: 76,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 64,
    y: 76,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "68 12 68 20 76 20 76 36 68 36 68 44 52 44 52 36 44 36 44 20 52 20 52 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-12",
    points: "92 104 28 104 28 12 24 12 24 0 96 0 96 12 92 12"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProvider2);
export default __webpack_public_path__ + "static/media/img-provider2.f6f4ee021054d4df44bf65c568785ddb.svg";
export { ForwardRef as ReactComponent };